import { Component, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ComponentsWithConfigsList, DeployedActorObject } from "../componentsWithConfigs.datamodel";
import { LSSEntityObject } from "../../shared/list/lssEntity.datamodel";
import { DEPLOYMENT_LEVEL_CATEGORIES, DeploymentLevelCategory } from "../../deployments/store/deployment.datamodel";
import { ConfigurationService } from "../store/configuration.service";
import { LssConfigurationEntity } from "../store/configuration.datamodel";
import { SizeOverlap } from './edit-configuration.datamodel';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ama-ng-app-store-edit-configuration',
    templateUrl: './edit-configuration.component.html',
    standalone: false
})
export class EditConfigurationComponent implements OnDestroy {
  @Input() cmpsWithConfigs!: ComponentsWithConfigsList;
  @Input() entitySelected!: LSSEntityObject;
  @Input() redefinedConfigSuccess!: string;
  @Input() selectedConfigurations: { [key: string]: string } = {};
  @Input() selectedEntities!: LssConfigurationEntity[];
  @Input() deployedActors!: DeployedActorObject[];
  @Input() editConfiguration = false;
  @Input() deploymentCategory: DeploymentLevelCategory = DEPLOYMENT_LEVEL_CATEGORIES.OFFICE;
  @Input() appId!: string;
  @Input() orgId!: string;
  @Input() displayDynamicForm!: boolean;
  @Input() containsPotentialConfigurationOverrides!: SizeOverlap;
  private readonly subscriptions = new Subscription();


  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly configService: ConfigurationService
  ) {}

  /**
   * Save the selected configurations for the selected entities and close the modal
   */
  save() {
    const payload = this.getSelectedConfigurations();
    this.subscriptions.add(
        this.configService.saveChangedConfigurationsAndOverrides(this.selectedEntities, this.selectedConfigurations, this.appId, payload)
            .subscribe(() => this.activeModal.close('CONFIRM'))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  /**
   * Get the selected configurations in the format required by the API
   * @private
   */
  private getSelectedConfigurations() {
    return this.cmpsWithConfigs.components.reduce((components, component) => {
      const name = component.configurations.find(config => config.guid === this.selectedConfigurations[component.component.id])?.name;
      return {
        ...components,
        guids: {...components.guids, [component.component.id]: this.selectedConfigurations[component.component.id]},
        names: {...components.names, [this.selectedConfigurations[component.component.id]]: name}
      };
    }, {guids: {}, names: {}});
  }

  protected readonly SizeOverlap = SizeOverlap;
}
